import {
  DefinitionApi,
  Configuration,
  GetProxyRequest,
  Proxy,
  InitOverrideFunction,
} from '@internal/plugin-api-gateway-common';

import {
  createApiRef,
  DiscoveryApi,
  IdentityApi,
} from '@backstage/core-plugin-api';

export const ProxyAPIRef = createApiRef<DefinitionApi>({
  id: 'plugin.api-gateway.service',
});

export class ProxyApiClient extends DefinitionApi {
  private client: DefinitionApi | undefined;

  constructor(
    protected readonly discoveryApi: DiscoveryApi,
    protected readonly identityApi: IdentityApi,
  ) {
    super();
    this.identityApi = identityApi;
    this.discoveryApi = discoveryApi;
  }

  async getClient() {
    if (!this.client) {
      const { token } = await this.identityApi.getCredentials();
      this.client = new DefinitionApi(
        new Configuration({
          basePath: await this.discoveryApi.getBaseUrl('api-gateway'),
          accessToken: token,
        }),
      );
    }
    return this.client;
  }

  async getProxy(
    requestParameters: GetProxyRequest,
    initOverrides?: RequestInit | InitOverrideFunction,
  ): Promise<Proxy> {
    const client = await this.getClient();
    return client.getProxy(requestParameters, initOverrides);
  }
}
